import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlignHorizontalCenter: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="align-horizontal-center, alignment"><path d="M20.25 3.75L3.75 3.75L3.75 20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M12 16.25L12 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAlignHorizontalCenter;
